"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.demo1 = demo1;
exports.demo2 = demo2;
exports.demo3 = demo3;
exports.demo4 = demo4;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var main_1 = require("../main");
var data_description_1 = require("./data/data-description");
/** Demo showing small data with a lot of customizations */
function demo1(divElementOrId) {
  var items = [{
    col: 1,
    row: 'A',
    score: 0.0
  }, {
    col: 1,
    row: 'B',
    score: 0.2
  }, {
    col: 1,
    row: 'C',
    score: 0.4
  }, {
    col: 2,
    row: 'A',
    score: 0.6
  }, {
    col: 2,
    row: 'B',
    score: 0.8
  }, {
    col: 2,
    row: 'C',
    score: 1.0
  }, {
    col: 3,
    row: 'A',
    score: 0.3
  }, {
    col: 3,
    row: 'C',
    score: 0.7
  }, {
    col: 4,
    row: 'B',
    score: 0.5
  }];
  // Creating a heatmap with 4 columns (1, 2, 3, 4) and 3 rows (A, B, C)
  // Heatmap<number, string, { col: number, row: string, score: number }>
  var heatmap = main_1.Heatmap.create({
    xDomain: [1, 2, 3, 4],
    yDomain: ['A', 'B', 'C'],
    data: items,
    x: function (d) {
      return d.col;
    },
    y: function (d) {
      return d.row;
    },
    filter: function (d, x, y, xIndex, yIndex) {
      return d.score > 0;
    }
  });
  var colorScale = main_1.ColorScale.continuous([0, 0.5, 1], ['#eeeeee', 'gold', 'red']);
  heatmap.setColor(function (d) {
    return colorScale(d.score);
  });
  heatmap.setTooltip(function (d, x, y, xIndex, yIndex) {
    return "<div style=\"font-weight: bold; margin-bottom: 0.5em;\">Score: ".concat(d.score, "</div>Column ").concat(x, ", Row ").concat(y, "<br>Indices [").concat(xIndex, ",").concat(yIndex, "]");
  });
  setTimeout(function () {
    return heatmap.setFilter(undefined);
  }, 2000);
  heatmap.setVisualParams({
    xGapPixels: 0,
    yGapPixels: 0
  });
  heatmap.events.select.subscribe(function (e) {
    if (e.cell) {
      console.log('selecting', e.cell.datum, e.cell.x, e.cell.y, e.cell.xIndex, e.cell.yIndex, e.sourceEvent);
    } else {
      console.log('selecting nothing');
    }
  });
  heatmap.events.zoom.subscribe(function (e) {
    if (e) {
      setTextContent('#xminindex', e.xMinIndex);
      setTextContent('#xmaxindex', e.xMaxIndex);
      setTextContent('#xmin', e.xMin);
      setTextContent('#xmax', e.xMax);
      setTextContent('#xfirstvisibleindex', e.xFirstVisibleIndex, 0);
      setTextContent('#xlastvisibleindex', e.xLastVisibleIndex, 0);
      setTextContent('#xfirstvisible', e.xFirstVisible, 0);
      setTextContent('#xlastvisible', e.xLastVisible, 0);
    }
  });
  heatmap.setZooming({
    axis: 'x'
  });
  heatmap.render(divElementOrId);
  window.heatmap = heatmap;
}
/** Demo showing a big data example (200_000 x 20) */
function demo2(divElementOrId) {
  var data = data_description_1.DataDescription.createDummy(2e5, 20);
  var heatmap = main_1.Heatmap.create(data); // Heatmap<number, number, number>
  heatmap.setVisualParams({
    xGapRelative: 0,
    yGapRelative: 0
  });
  heatmap.setColor(main_1.ColorScale.continuous('Magma', [0, 1]));
  heatmap.render(divElementOrId);
  heatmap.setZooming({
    axis: 'x'
  });
  window.heatmap = heatmap;
}
/** Demo generating the heatmap-component logo */
function demo3(divElementOrId) {
  var items = [{
    col: 1,
    row: 'A',
    score: 0.6
  }, {
    col: 1,
    row: 'B',
    score: 0.4
  }, {
    col: 1,
    row: 'C',
    score: -1
  }, {
    col: 2,
    row: 'B',
    score: 0.6
  }, {
    col: 3,
    row: 'A',
    score: 0.6
  }, {
    col: 3,
    row: 'B',
    score: 0.8
  }, {
    col: 3,
    row: 'C',
    score: 1
  }];
  var heatmap = main_1.Heatmap.create({
    xDomain: [1, 2, 3],
    yDomain: ['A', 'B', 'C'],
    data: items,
    x: function (d) {
      return d.col;
    },
    y: function (d) {
      return d.row;
    }
  });
  var colorScale = main_1.ColorScale.continuous([-1, 0, 1], ['#E13D3D', 'white', '#2C8C11']); // like d3.scaleLinear([-1, 0, 1], ['#E13D3D', 'white', '#2C8C11']);
  heatmap.setColor(function (d) {
    return colorScale(d.score);
  });
  heatmap.setVisualParams({
    xGapRelative: 0.1,
    yGapRelative: 0.1,
    xGapPixels: null,
    yGapPixels: null
  });
  heatmap.render(divElementOrId);
  window.heatmap = heatmap;
}
/** Demo showing an AlphaFold PAE matrix from real data */
function demo4(divElementOrId) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    var uniprotIdFromUrl, uniprotId, pae, msg, heatmap, colorScale;
    var _a;
    return tslib_1.__generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          uniprotIdFromUrl = new URL(window.location).searchParams.get('uniprot-id');
          uniprotId = uniprotIdFromUrl !== null && uniprotIdFromUrl !== void 0 ? uniprotIdFromUrl : 'P06213';
          setTextContent('#uniprot-id', uniprotId);
          return [4 /*yield*/, fetchPAEMatrix(uniprotId, undefined)];
        case 1:
          pae = _b.sent();
          if (!pae) {
            msg = "Failed to fetch data for ".concat(uniprotId, ".");
            setTextContent('#error', "Error: ".concat(msg));
            throw new Error(msg);
          }
          heatmap = main_1.Heatmap.create({
            xDomain: (0, lodash_1.range)(1, pae.n + 1),
            yDomain: (0, lodash_1.range)(1, pae.n + 1),
            data: pae.data,
            x: function (d, i) {
              return i % pae.n + 1;
            },
            y: function (d, i) {
              return Math.floor(i / pae.n) + 1;
            }
          });
          colorScale = main_1.ColorScale.continuous('Greens', [0, 32], [1, 0]);
          heatmap.setColor(function (d) {
            return colorScale(d);
          });
          heatmap.setTooltip(null);
          heatmap.setVisualParams({
            xGapRelative: 0,
            yGapRelative: 0
          });
          (_a = heatmap.extensions.marker) === null || _a === void 0 ? void 0 : _a.update({
            freeze: true
          });
          heatmap.setBrushing({
            enabled: true
          });
          heatmap.events.brush.subscribe(function (e) {
            var _a, _b;
            var selection = (e === null || e === void 0 ? void 0 : e.selection) ? "Scored residue (x): ".concat(e.selection.xFirst, "-").concat(e.selection.xLast, " / Aligned residue (y): ").concat(e.selection.yFirst, "-").concat(e.selection.yLast) : 'None';
            var left = e.selection ? e.selection.xMinIndex / pae.n : 0;
            var width = e.selection ? (e.selection.xMaxIndex - e.selection.xMinIndex) / pae.n : 0;
            var top = e.selection ? e.selection.yMinIndex / pae.n : 0;
            var height = e.selection ? (e.selection.yMaxIndex - e.selection.yMinIndex) / pae.n : 0;
            var color = e.type === 'end' ? '#777777' : '#aaaaaa';
            setTextContent('#selection', selection);
            (_a = document.getElementById('xindicator')) === null || _a === void 0 ? void 0 : _a.setAttribute('style', "left: ".concat(left * 100, "%; width: ").concat(width * 100, "%; background-color: ").concat(color, ";"));
            (_b = document.getElementById('yindicator')) === null || _b === void 0 ? void 0 : _b.setAttribute('style', "top: ".concat(top * 100, "%; height: ").concat(height * 100, "%; background-color: ").concat(color, ";"));
          });
          heatmap.render(divElementOrId);
          window.heatmap = heatmap;
          return [2 /*return*/];
      }
    });
  });
}
function fetchPAEMatrix(uniprotId, cut) {
  return tslib_1.__awaiter(this, void 0, void 0, function () {
    var url, response, js, values;
    return tslib_1.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = "https://alphafold.ebi.ac.uk/files/AF-".concat(uniprotId, "-F1-predicted_aligned_error_v4.json");
          return [4 /*yield*/, fetch(url)];
        case 1:
          response = _a.sent();
          if (!response.ok) return [2 /*return*/, undefined];
          return [4 /*yield*/, response.json()];
        case 2:
          js = _a.sent();
          values = js[0].predicted_aligned_error;
          if (cut !== undefined) {
            values = values.slice(0, cut).map(function (row) {
              return row.slice(0, cut);
            });
          }
          return [2 /*return*/, {
            n: values.length,
            data: values.flatMap(function (x) {
              return x;
            })
          }];
      }
    });
  });
}
/** Set text content to all HTML elements selected by `elementSelector`.
 * Example: `setTextContent('#element-to-change', 'changed text here');` */
function setTextContent(elementSelector, content, numberPrecision) {
  if (numberPrecision === void 0) {
    numberPrecision = 4;
  }
  var elements = document.querySelectorAll(elementSelector);
  if (typeof content === 'number' && numberPrecision >= 0) content = content.toFixed(numberPrecision);
  elements.forEach(function (element) {
    return element.textContent = "".concat(content);
  });
}